export default "__VITE_ASSET__DnzgUYon__"